import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Alert from './Alert';

const EmailVerification = () => {
  const { handleVerifyCode, sendVerifyCode, alert, showAlert } = useAuth();
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');

  const handleVerify = () => handleVerifyCode(userId, code);
  const handleResend = () => sendVerifyCode(userId);

  return (
    <>
      <Alert
        type={alert.type}
        message={alert.message}
        isOpen={alert.isOpen}
        onClose={() => showAlert({ isOpen: false, type: '', message: '' })}
      />

      <div className="min-h-screen flex items-center justify-center bg-[#020617] px-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="max-w-md w-full bg-[#0f172a] border border-slate-800 rounded-2xl p-8 shadow-2xl"
        >
          {/* Header */}
          <div className="text-center space-y-3 mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-500/10 rounded-full mb-2">
              <span className="text-3xl">🔑</span>
            </div>
            <h1 className="text-2xl font-bold text-white tracking-tight">Email Verification</h1>
            <p className="text-slate-400 text-sm">Enter the 6-digit code sent to your inbox</p>
          </div>

          {/* Input Area */}
          <div className="space-y-6">
            <input
              type="text"
              maxLength="6"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ''))}
              placeholder="0 0 0 0 0 0"
              className="w-full bg-slate-900 border border-slate-700 rounded-xl py-4 text-3xl font-mono font-bold text-center text-yellow-500 focus:border-yellow-500/50 outline-none transition-all placeholder:opacity-20 tracking-[10px]"
            />

            <div className="space-y-3">
              <motion.button
                whileTap={{ scale: 0.98 }}
                onClick={handleVerify}
                disabled={code.length !== 6}
                className="w-full py-4 bg-yellow-500 hover:bg-yellow-400 disabled:bg-slate-700 disabled:text-slate-500 text-slate-950 font-bold rounded-xl transition-colors shadow-lg shadow-yellow-500/10"
              >
                Confirm Verification
              </motion.button>

              <button
                onClick={handleResend}
                className="w-full py-3 text-slate-400 hover:text-white text-sm font-medium transition-colors"
              >
                Didn't receive code? <span className="text-yellow-500">Resend</span>
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-slate-800 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-xs text-slate-500 hover:text-slate-300 uppercase tracking-widest transition-colors"
            >
              ← Back to Login
            </button>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default EmailVerification;